var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/default/customizable/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/default/customizable/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2316384,1 C11.2853845,1 11.3351678,1.01990241 11.3729634,1.05771641 L11.3729634,1.05771641 L14.6808025,4.36753684 C14.6992297,4.38594923 14.7138922,4.4078192 14.7238489,4.43189845 C14.7338551,4.45597276 14.7390068,4.48178576 14.7390068,4.50785139 C14.7390068,4.53391703 14.7338551,4.55972508 14.7238489,4.58380433 C14.7138922,4.60788359 14.6992297,4.62975356 14.6808025,4.64816594 L14.6808025,4.64816594 L6.24404704,13.0849015 C6.21615849,13.1147715 6.17836283,13.1327034 6.1385362,13.1406291 L6.1385362,13.1406291 L2.79091515,13.7277746 C2.75110834,13.7337684 2.71130648,13.7377313 2.67149967,13.7377313 C2.4943653,13.7377313 2.32917397,13.6680842 2.19781546,13.5406786 C2.12078264,13.4644929 2.06348481,13.3706229 2.03088543,13.2672916 C1.99828605,13.1639604 1.99136592,13.0541895 2.01072939,12.9475889 L2.01072939,12.9475889 L2.59786004,9.59997276 C2.60582041,9.56014613 2.62373249,9.52433189 2.65358759,9.49446192 L2.65358759,9.49446192 L11.0903628,1.05771641 C11.1281585,1.01990241 11.1778922,1 11.2316384,1 Z M11.2316384,3.04997895 L4.01294363,10.2666724 L3.70245942,12.0380161 L5.47178697,11.7255455 L12.6905114,4.50884706 L11.2316384,3.04997895 Z",
    id: "Shape",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizable);
export default __webpack_public_path__ + "static/media/customizable.e0e74cc778e40a773447a5b378cc8653.svg";
export { ForwardRef as ReactComponent };